import { formattedCurrencyAmount, intervalFormatter } from './stringFormatters';

export function couponDescription(coupon, interval?, interval_count?, currency?, price?) {
  if (!coupon) return '';

  const promotion = coupon.percent_off
    ? `${coupon.percent_off}% off`
    : coupon.amount_off
      ? `${currency.toUpperCase()}${formattedCurrencyAmount(coupon.amount_off, currency)} off`
      : '';

  let duration;

  switch (coupon.duration) {
    case 'forever':
      duration = ' forever';
      break;
    case 'once':
      duration = interval
        ? ` your first ${intervalFormatter(interval, interval_count)}`
        : ' your first purchase';
      break;
    case 'repeating':
      duration = ` for ${intervalFormatter('month', coupon.duration_in_months)}`;
      break;
  }

  return `${promotion} ${duration}`;
}

export function validCoupon(coupon, price) {
  if (!coupon || !price) return true;

  if (!coupon.duration_in_months) return true;

  return price.recurring?.interval === 'month';
}
